import React from 'react'
import date from '@/utils/date'

const PostMetadata = ({ author, publishDate, categories, className }) => (
	<div className={className}>
		{!!author && <p className="font-serif text-lg">by {author.name}</p>}
		<p className="mt-4">
			<time dateTime={publishDate}>
				{date(publishDate)}
			</time>

			<span className="inline-block mx-4">//</span>

			<span className="inline-block text-orange empty:text-grounding-navy/30 empty:before:content-['No_tags']">
				{categories.map(c => c.name).join(', ')}
			</span>
		</p>
	</div>
)

export default PostMetadata
